import cssMobile from '../../css/editorMobile.module.css'
import IconButton from './IconButton'
import {faBars, faCartPlus, faSpinner} from '@fortawesome/free-solid-svg-icons'
import ShareIcon from '../icons/ShareIcon'
import ExitIcon from '../icons/ExitIcon'
import {useTranslation} from 'react-i18next'

interface TopButtonsProps {
  onMenuClick?: () => void
  onCartClick?: () => void
  price: number
  onShareClick?: () => void
  cartDisabled?: boolean
  loading?: boolean
}

export default function TopButtons({
  onMenuClick,
  onCartClick,
  price,
  onShareClick,
  cartDisabled = false,
  loading,
}: TopButtonsProps) {
  const {t, i18n} = useTranslation()
  return (
    <div className={cssMobile.buttonsContainer}>
      <IconButton color="primary" icon={faBars} onClick={onMenuClick} />
      <IconButton
        color="primary"
        iconcomponent={<ShareIcon />}
        onClick={onShareClick}
      />
      <IconButton
        color="primary"
        iconcomponent={<ExitIcon />}
        onClick={() => {
          //@ts-ignore
          if (window.parent.window.iframesExitFullscreen) {
            //@ts-ignore
            window.parent.window.iframesExitFullscreen()
          }
        }}
      />
      {price ? (
        <div className={cssMobile.price}>
          <span>
            {t('{{price}} Ft', {price: price.toLocaleString(i18n.language)})}
          </span>
        </div>
      ) : null}
      <IconButton
        color="primary"
        icon={loading ? faSpinner : faCartPlus}
        className={loading ? cssMobile.spinner : ''}
        onClick={onCartClick}
        disabled={cartDisabled}
      />
    </div>
  )
}
